import { forwardRef, type SVGProps } from 'react';

export interface PlusBoxIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const PlusBoxIcon = forwardRef<SVGSVGElement, PlusBoxIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 32 32">
    <path
      d="M27.9004 6C27.9004 4.95066 27.0493 4.09961 26 4.09961H6C4.95066 4.09961 4.09961 4.95066 4.09961 6V26C4.09961 27.0493 4.95066 27.9004 6 27.9004H26C27.0493 27.9004 27.9004 27.0493 27.9004 26V6ZM30.0996 26C30.0996 28.2644 28.2644 30.0996 26 30.0996H6C3.73563 30.0996 1.90039 28.2644 1.90039 26V6C1.90039 3.73563 3.73563 1.90039 6 1.90039H26C28.2644 1.90039 30.0996 3.73563 30.0996 6V26Z"
      fill="currentColor"
    />
    <path
      d="M14.9004 22V10C14.9004 9.39249 15.3925 8.90039 16 8.90039C16.6075 8.90039 17.0996 9.39249 17.0996 10V22C17.0996 22.6075 16.6075 23.0996 16 23.0996C15.3925 23.0996 14.9004 22.6075 14.9004 22Z"
      fill="currentColor"
    />
    <path
      d="M22 14.9004C22.6075 14.9004 23.0996 15.3925 23.0996 16C23.0996 16.6075 22.6075 17.0996 22 17.0996H10C9.39249 17.0996 8.90039 16.6075 8.90039 16C8.90039 15.3925 9.39249 14.9004 10 14.9004H22Z"
      fill="currentColor"
    />
  </svg>
));

PlusBoxIcon.displayName = 'PlusBoxIcon';
